export const COOKIE_KEY_CURRENT_ORGANIZATION_ID = 'currentOrganizationId';
export const COOKIE_KEY_CURRENT_ORGANIZATION_SUBDOMAIN =
  'currentOrganizationSubdomain';
export const PERSONAL_ORGANIZATION_ID = 'personal';
export const SUPER_ADMIN_ORGANIZATION_ID = 'Super admin';
export const SUBSCRIBER_USER_TYPE = 'subscriber';
export const MERCHANT_USER_TYPE = 'merchant';
